import React, {useEffect} from 'react'
import {SlotComponent} from '../../types/ui'
import {Box, Container, Stack, Text} from '../../vanilla'
import {Slot} from './Slot'
import {Seo} from '../seo'
import {usePageDataTracking} from '../../analytics/page-tracking'
import { ContentPageType } from '../../types/cms/navigation'
import { SLOT_SCHEMAS } from './utils'
import { DefaultContentBody } from 'dc-delivery-sdk-js'
import { PageHeader } from './partials/pageHeader'
import { BreadcrumbsContent } from './partials/breadcrumbsContent'
import { SlotItem } from '../../types/cms'

export const ContentPage: SlotComponent<ContentPageType | DefaultContentBody> = ({content}) => {
  const sendPageData = usePageDataTracking()
  useEffect(() => {
    if (content && content?.slotContent) {
      sendPageData(pageType, pageCategory)
    }
  }, []);

  if (!content || !content?.slotContent) {
    return null
  }
  const {BreadCrumb, pageHeading, backgroundColor} = content

  const slotContent: SlotItem[] = content?.slotContent

  const heroContent = slotContent.find(
    ({_meta}) =>
      _meta?.schema === SLOT_SCHEMAS.CONTENT_HERO_SLOT || _meta.schema === SLOT_SCHEMAS.LANDING_HERO,
  )

  const bodyContent = slotContent.filter(
    ({_meta}) =>
      _meta?.schema === SLOT_SCHEMAS.CONTENT_SLOT || _meta?.schema === SLOT_SCHEMAS.LANDING_BODY,
  )
  
  const pageType = 'content'
  const pageCategory = 'Landing'

  return (
    <Box paddingBottom="20px">
      <Seo title={content?.SEO?.pageTitle} description={content?.SEO?.pageDescription} />
      <Container
        style={{backgroundColor: backgroundColor?.color || 'transparent'}}
        padding={backgroundColor?.name === 'White' ? '24px' : '0px'}
        paddingBottom={backgroundColor?.name === 'White' ? '40px' : '0px'}
      >
        <BreadcrumbsContent breadCrumb={BreadCrumb}></BreadcrumbsContent>
        {heroContent && <Slot data={heroContent} />}
        <PageHeader pageHeading={pageHeading}></PageHeader>
        {bodyContent?.length ? (
          <Stack spacing={['16px', '24px']}>
            {bodyContent?.map((content) => {
              return content && <Slot data={content} />
            })}
          </Stack>
        ) : null}
      </Container>
    </Box>
  )
}
